import { Button, ButtonGroup, VStack } from "@chakra-ui/react";
import { Key, ReactElement } from "react";
import { ListOption } from "../core/types";
import Combobox from "./Combobox";

interface ComboModeBoxProps<T extends Key> {
  value: Array<T>;
  options: ListOption<T>[];
  containAll: boolean;
  onChange?: (value: Array<T>) => void;
  onContainAllChange?: (containAll: boolean) => void;
}

export default function ComboModeBox<T extends Key>(
  props: ComboModeBoxProps<T>
): ReactElement {
  const { value, options, containAll, onChange, onContainAllChange } = props;

  return (
    <VStack spacing="0" __css={{ select: { ps: "10", fontStyle: "italic" } }}>
      <ButtonGroup
        isAttached={true}
        size="xs"
        mt="1"
        ms="3"
        alignSelf="flex-start"
      >
        <Button
          variant={containAll ? undefined : "outline"}
          bg={containAll ? "gray.200" : "white"}
          px={containAll ? "calc(var(--chakra-space-2) + 1px)" : undefined}
          me="0 !important"
          onClick={() => onContainAllChange?.(true)}
        >
          And
        </Button>
        <Button
          variant={containAll ? "outline" : undefined}
          bg={containAll ? "white" : "gray.200"}
          px={containAll ? undefined : "calc(var(--chakra-space-2) + 1px)"}
          me="0 !important"
          onClick={() => onContainAllChange?.(false)}
        >
          Or
        </Button>
      </ButtonGroup>
      <Combobox
        value={value}
        options={options}
        onChange={onChange}
        borderBottomWidth="1px"
      />
    </VStack>
  );
}
